import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { AuthService } from '../auth.service';
import { GenericResponse } from '../../api-interfaces';
import { FuncsService, passwordsDontMatchValidator } from 'src/app/shared/funcs.service'
import { LogService } from 'src/app/shared/log.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.sass']
})
export class PasswordResetComponent implements OnInit {

  isSpinning: boolean = false;
  passwordResetForm!: UntypedFormGroup;
  temporaryPasswordVisible = false;
  newPasswordVisible = false;
  confirmNewPasswordVisible = false;

  constructor(
    private funcs: FuncsService,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private logger: LogService
  ) { }

  ngOnInit(): void {

    this.passwordResetForm = this.fb.group({
      temporaryPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      confirmNewPassword: [null, [Validators.required]],
    }, {validators:passwordsDontMatchValidator});
  }

  submitForm(): void {
    for (const i in this.passwordResetForm.controls) {
      this.passwordResetForm.controls[i].markAsDirty();
      this.passwordResetForm.controls[i].updateValueAndValidity();
    }

    let temporaryPassword: string = this.passwordResetForm.value["temporaryPassword"];
    let newPassword: string = this.passwordResetForm.value["newPassword"];
    let confirmNewPassword: string = this.passwordResetForm.value["confirmNewPassword"];

    if(!temporaryPassword || !newPassword || !confirmNewPassword) {
      return;
    }

    this.isSpinning = true;

    this.authService.resetPassword(temporaryPassword, newPassword)
    .subscribe(
      (response: GenericResponse) => {
        if(response["esito"] == "OK") {
          this.logger.log("Response OK");
        }
      },
      (err: any) => {this.isSpinning = false;},
      () => {this.isSpinning = false;}
    );
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }
}
